const firebaseConfig = {
    apiKey: "AIzaSyDkW7haD4a92J5mXK2AYGUxB1GUWR9LW_4",
    authDomain: "creative-agency-bd0.firebaseapp.com",
    projectId: "creative-agency-bd0",
    storageBucket: "creative-agency-bd0.appspot.com",
    messagingSenderId: "1079517307641",
    appId: "1:1079517307641:web:4328689a5b5b8cdad1b828"
};
export default firebaseConfig;